class ProductAccordion extends HTMLElement {
  constructor() {
    super();
    this.accordion = this.querySelector('details');
    this.init();
  }

  init() {
    if (this.accordion) {
      this.accordion.addEventListener('toggle', this.onToggle.bind(this));
    }
  }

  onToggle() {
    // Only act when accordion is being opened
    if (this.accordion.open) {
      // Find all other product accordions on the page and close them
      const allProductAccordions = document.querySelectorAll('product-accordion');
      
      allProductAccordions.forEach((accordionComponent) => {
        if (accordionComponent !== this) {
          const otherAccordion = accordionComponent.querySelector('details');
          if (otherAccordion && otherAccordion.open) {
            otherAccordion.open = false;
            const summary = otherAccordion.querySelector('summary');
            if (summary) {
              summary.setAttribute('aria-expanded', 'false');
            }
          }
        }
      });
      
      
      // Set aria-expanded for accessibility
      const currentSummary = this.accordion.querySelector('summary');
      if (currentSummary) {
        currentSummary.setAttribute('aria-expanded', 'true');
      }
    }
  }
}

customElements.define('product-accordion', ProductAccordion);
